import {createStyles} from '@material-ui/core/styles';
import {makeStyles} from '@material-ui/core';
import type {Theme} from '@material-ui/core/styles';
import * as colors from 'assets/theme/colors';

export default makeStyles((theme: Theme) =>
    createStyles({
        requiredFields: {
            ...theme.typography.caption,
            color: colors.accent.A00,
        },
    })
);
